import IndiaMap from '@svg-maps/india';

// Fuzzy-match state name to our SVG-map location id (id like 'gj' -> Gujarat).
const nameToId = {};
IndiaMap.locations.forEach((loc) => {
  nameToId[loc.name.toLowerCase()] = loc.id;
});

function slug(s) {
  return String(s || '').trim().toLowerCase();
}

/**
 * Renders a coloured India-states heatmap.
 * @param {Array} assignments  [{state, partner_name, partner_city}, ...]
 * @param {Function} onHover   (state|null) => void
 */
export default function IndiaHeatmap({ assignments = [], onHover }) {
  const assignedIds = new Set();
  const idToAssignment = {};
  assignments.forEach((a) => {
    const id = nameToId[slug(a.state)];
    if (id) {
      assignedIds.add(id);
      idToAssignment[id] = a;
    }
  });

  const total = IndiaMap.locations.length;
  const coverage = Math.round((assignedIds.size / total) * 100);

  return (
    <div className="w-full" data-testid="territory-heatmap">
      <div className="flex items-center gap-4 justify-between mb-3 text-xs">
        <div className="flex items-center gap-3">
          <span className="inline-flex items-center gap-1.5"><span className="w-3 h-3 rounded-sm" style={{background: '#0B2E6F'}} /> Assigned</span>
          <span className="inline-flex items-center gap-1.5"><span className="w-3 h-3 rounded-sm border border-black/10" style={{background: '#E5E7EB'}} /> Open</span>
        </div>
        <div className="text-neutral-500">
          Coverage <span className="font-semibold text-navy">{assignedIds.size}/{total}</span> · <span className="font-semibold text-navy">{coverage}%</span>
        </div>
      </div>
      <div className="relative bg-cream rounded-2xl border border-black/5 overflow-hidden">
        <svg viewBox={IndiaMap.viewBox} xmlns="http://www.w3.org/2000/svg" className="w-full h-auto" style={{maxHeight: 560}}>
          {IndiaMap.locations.map((loc) => {
            const isAssigned = assignedIds.has(loc.id);
            const a = idToAssignment[loc.id];
            return (
              <path
                key={loc.id}
                d={loc.path}
                fill={isAssigned ? '#0B2E6F' : '#E5E7EB'}
                stroke="#ffffff"
                strokeWidth="0.7"
                onMouseEnter={() => onHover && onHover(a ? { ...a, state: loc.name } : { state: loc.name, unassigned: true })}
                onMouseLeave={() => onHover && onHover(null)}
                style={{cursor: 'pointer', transition: 'fill 0.2s'}}
                data-testid={`heatmap-state-${loc.id}`}
              >
                <title>{isAssigned ? `${loc.name} — ${a.partner_name}` : `${loc.name} — Open`}</title>
              </path>
            );
          })}
        </svg>
      </div>
    </div>
  );
}
